export const SET_OPTIONS = 'handbook/SET_OPTIONS'
export const SET_SINGLE_OPTIONS = 'handbook/SET_SINGLE_OPTIONS'
